export default {
    ru: 'RU',
    fr: 'FR',
    login: 'S’identifier',
    scholarships: 'Bourses',
    faq: 'FAQ',
    blog: 'Blog',
    contacts: 'Contacts'
}